import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = '/marketplace-sw.js';
    navigator.serviceWorker.register(swUrl)
      .then((reg) => console.log('SW registered:', reg.scope, 'url:', swUrl))
      .catch((err) => console.log('SW registration failed:', err));
  });
}